<template>
    <div class="neopark-dis-around">
        <div class="container">
            <div class="dis-around-cards">
                <div class="card-item" v-for="item in salesCard.neopark_land_cards.cards">
                    <strong v-html="item.title"></strong>
                    <div class="card-desc" v-html="item.desc"></div>
                    <div class="card-img"><img :src="item.img" alt=""></div>
                    <div class="card-icons-list">
                        <div class="icon-item" v-for="list in item.icon_list">
                            <div class="icon-img"><img :src="list.icon" alt=""></div>
                            <p v-html="list.desc"></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>   
</template>

<script>
    import {mapGetters} from 'vuex'
    export default {
        name: 'neopark-dis-around',
        components: {
        },
        data () {
            return {
                projectNameG: window.host,
                globalLang: window.GlobalLang, 
            }
        },
        computed: mapGetters({
            salesCard: 'loadSalesCardContent',
            isMobileChecker: 'loadIsMobileChecker',
        }),
        methods: {
        },
        beforeCreate() {
        },
        created () {
        },
        mounted () {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/sales/sales-land-partials/neopark/dis-around.scss';
    @import '@/styles/components/sales/sales-land-partials/neopark/respond/dis-around-respond.scss';
    // @import '@/styles/components/sales/respond/land-about-respond.scss';
</style>